<template>
  <div>
    <div class="content_box row-column acea-row row-center-wrapper">
      <div
        :style="`backgroundImage: url(` + topHeaderImg + `)`"
        class="header_box row-column acea-row row-center-wrapper"
      >
        <div class="item">关于我们</div>
        <div class="item_small">-ABOUT US-</div>
      </div>
      <div class="acea-row row-column row-center-wrapper top_big_small_box">
        <div class="about_top_box acea-row row-middle">
          <div class="gary_text">COMPANY</div>
          <div class="primary_color_text">PROFILE</div>
        </div>
        <div class="top_text_box_two">公司简介</div>
      </div>
      <div class="profile_content acea-row row-column row-center-wrapper">
        广东庞盛科技有限公司是国内专注于智能低压供电保护，智慧安全用电，多路智能控制等产品的高新技术企业。公司成立于2013年，是一家集研发，生产，销售为一体的创新型企业，本着“高效、安全，方便”的经营理念，以“共享，共创，共赢”的核心价值观，着力”为客户减少用电维护成本，时刻掌握设备的运行状态，提高产品信誉，有效利用资源”的企业使命，为市场提供最优性价比的产品和整体解决方案。
      </div>
      <div class="profile_content acea-row row-column row-center-wrapper">
        经过多年的努力创新，庞盛科技先后开发了单相、三相智能重合闸保护、智能照明保护、智能监控电源保护智慧物联电源管理终端、智能家居控制与保护等多个系列数十款智能电源保护产品，并先后获得数项发明专利和数十项实用新型专利，企业相续通过ISO9001-2015质量管理体系，产品通过信息产业通信产品防护性能质量监督检验中心检验，欧盟的CE认证(Conformityof Europe),欧盟的RoHs认证等。
      </div>
      <div class="profile_content acea-row row-column row-center-wrapper">
        目前，庞盛科技的创新产品已用在5G通讯基站、雪亮工程、智能交通、卫星地面接收站、电动汽车兖电桩、智慧教育，智慧楼宇，智慧消防和智慧农业等相关行业，并致力为用户提供咨询规划、软件研发、硬件配套、运维系统的整体解决方案。
      </div>
     <img
        :src="info_big_image"
        class="content_info_img_box row-column acea-row row-center-wrapper"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "Profile",
  data() {
    return {
      topHeaderImg: require("@/assets/about_company/profile/hader_bg.png"),
      info_big_image: require("@/assets/about_company/profile/info_big_image.png"),
    };
  },
};
</script>
<style scoped>
.content_box {
  width: 100%;
}
.content_box .header_box {
  width: 100%;
  height: 360px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.content_box .header_box .item {
  color: #fff;
  font-size: 40px;
}
.content_box .header_box .item_small {
  color: #fff;
  font-size: 23px;
}
/* 关于我们 begin */
.top_big_small_box {
  margin-bottom: 4%;
  margin-top: 4%;
}
.top_big_small_box .about_top_box .gary_text {
  font-size: 42px;
  font-weight: bolder;
  color: #7f7f7f;
}
.top_big_small_box .about_top_box .primary_color_text {
  margin-left: 10px;
  color: #313493;
  font-size: 42px;
  font-weight: bolder;
}

.top_big_small_box .top_text_box_two {
  color: #000000;
  font-size: 35px;
  margin-top: 10px;
  font-weight: bolder;
}

/* 关于我们 end */
.content_box .profile_content {
  color: #333333;
  font-size: 20px;
  width: 60%;
  line-height: 45px;
  margin-bottom: 40px;
}
.content_box .content_info_img_box{
    margin: 4% 0px;
     width: 60%;
}
</style>



// WEBPACK FOOTER //
// src/views/aboutCompany/profile.vue